export default "__VITE_ASSET__64022802__"